import React, { Component } from "react";
import styles from "./ToggleTypes.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown, faAngleUp } from "@fortawesome/free-solid-svg-icons";
import { connect } from "react-redux";
import { toggleType } from "../../../../actions/Map/mapActions";

class ToggleTypes extends Component {
    constructor(props) {
        super(props);
        this.state = {
          extended: false,
          toggleAll: true,
        };
    }

    componentDidMount = () => {
      for (var i = 0; i < this.props.types.length; i++) {
        this.props.toggleType({
          category: this.props.category,
          type: this.props.types[i],
          value: true
        })
      }
    }

    componentWillUnmount = () => {
      // If category is extended, set to undefined
      if (this.props.extendedCategory === this.props.category) {
        this.props.extendCategory(undefined)
      }
    }

    toggleType = (type, value) => {
      // Determine wether arrow for all should be true or false
      if (value === false){
        var length = this.props.types.length;
        var allTrue = true;
        for (var i = 0; i < length; i++) {
          let t = this.props.types[i];
          if (this.props.toggleTypes[this.props.category][t] === false && t !== type){
            allTrue = false;
          }
        }
        if (allTrue === true){
          this.setState({
            toggleAll: true
          })
        }
      }

      if (value === true && this.state.toggleAll === true){
        this.setState({ toggleAll : false })
      }
      // Cast value to boolean and invert
      var valueBoolean = ! Boolean(value);

      this.props.toggleType({
        category: this.props.category,
        type: type,
        value: valueBoolean
      })
      // Get latest markers
      this.props.getMarkers();
    }

    toggleAll = () => {
      if (this.state.toggleAll === true){
        this.setState({ toggleAll : false })
        for (var i = 0; i < this.props.types.length; i++) {
          this.toggleType(this.props.types[i], true)
        }
      } else {
        for (var j = 0; j < this.props.types.length; j++) {
          this.setState({ toggleAll : true })
          this.toggleType(this.props.types[j], false)
        }
      }
    }

    render() {
      return (
        <div className={styles.ToggleTypes}>
        <div className={styles.Category}
          onClick={() => this.props.extendCategory(this.props.category)}
        >
          <label>
            <input
              className={styles.InputCheckboxField}
              type="checkbox"

              checked={this.state.toggleAll}
              onChange={() => this.toggleAll()}
            />
              <h6>
                {this.props.category.charAt(0).toUpperCase()
                  + this.props.category.slice(1).toLowerCase()}
              </h6>
          </label>

          <FontAwesomeIcon
            className={styles.dropdownButton}
            icon={(this.props.extendedCategory === this.props.category)
              ? faAngleUp : faAngleDown}
            />
          </div>

          <div className={styles.break}>{""}</div>
          
          {(this.props.extendedCategory === this.props.category) &&
            this.props.types.map((type) =>
            (<div key={type} className={styles.Types}>
              <label>
                <input
                  className={styles.InputCheckboxField}
                  type="checkbox"
                  value={this.props.toggleTypes[this.props.category][type]}
                  defaultChecked={this.props.toggleTypes[this.props.category][type]}
                  onChange={() => this.toggleType(type, this.props.toggleTypes[this.props.category][type])}
                />
                <span>{type}</span>
              </label>
            </div>)
          )}
        </div>
      )
    }
}

function mapStateToProps(state) {
  return {
    toggleTypes: state.map.toggleTypes,
  };
}

const actions = {
  toggleType
};

export default connect(
  mapStateToProps,
  actions
)(ToggleTypes);



// WEBPACK FOOTER //
// ./src/components/pages/Map/ToggleTypes/ToggleTypes.js